exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-loading{width:100%;height:100%;display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;-ms-flex-align:center;align-items:center}.dv-loading .loading-tip{font-size:15px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/loading/src/main.css
// module id = 1100
// module chunks = 45